<template>
    <div>
        <div class="row">
            <div class="col-12">
                <h3 class="font-weight-bold">เลือกรายการขนส่ง
                    <span class="text-muted">(รูปแบบการจัดส่ง : {{ noteToShop }})</span>
                </h3>
            </div>
        </div>
        <div class="scroll-table scroll-bar-pop scrollbar-style table-responsive">
            <table class="table">
                <thead>
                    <tr class="text-center">
                        <th colspan="2">รายชื่อขนส่ง</th>
                        <!-- <th>ระยะเวลาขนส่ง</th> -->
                        <th>ราคาจัดส่ง</th>
                        <th>หมายเหตุ</th>
                        <th>การใช้งาน</th>
                    </tr>
                </thead>
                <tbody class="table-tbody">
                    <template v-for="( courier , keyId ) in courierList">
                        <tr :key="keyId" 
                            :class="['text-center', displayLock(courier) ? 'filter-gray' : '']"
                        >
                            <td>
                                <img 
                                    class="img-icon mt-3" 
                                    :src="courier['shipment'][0].src" 
                                    img-alt="courierIcon" 
                                    width="150" 
                                />
                            </td>
                            <td>
                                <h4 class="courier-name text-center">
                                    {{courier['shipment'][0].courier_name}}
                                </h4>
                            </td>
                            <td>
                                {{courier.total_price | numFormat('0,0.00')}} บาท
                                <div 
                                    v-if="courier.total_remote_area > 0" 
                                    class="small text-specialarea"
                                    v-b-tooltip.hover.bottom title="ค่าบริการพิเศษสำหรับพื้นที่ห่างไกล"
                                >
                                    ( +{{ courier.total_remote_area | numFormat('0,0.00') }} )
                                </div>
                                <div 
                                    v-if="courier.total_fuel_surcharge > 0"
                                    class="small text-danger"
                                    v-b-tooltip.hover.bottom title="Additional Fuel Charge"
                                >
                                    ( +{{ courier.total_fuel_surcharge | numFormat('0,0.00') }} )
                                </div>
                            </td>
                            <td>
                                <template v-for="(item, index) in courier.shipment">
                                    <span :key="index">
                                        <span v-if="item.remark_area_delay" class="text-yellow">
                                            * {{ item.remark_area_delay }} <br/>
                                        </span>
                                        <span v-else-if="item.remark_area_freeze" class="text-red">
                                            * {{ item.remark_area_freeze }} <br/>
                                        </span>
                                        <span v-else-if="!item.status || courier.total_price === 0" class="text-muted"> 
                                            {{ (!item.status ) ? errorCheckPrice(item) : 'ไม่พบเรทราคา' }} <br/>
                                        </span>
                                    </span>
                                </template>
                            </td>
                            <td>
                                <b-button 
                                    :variant="(keyId === isSelected.courierId) ? 'outline-primary' : 'primary' "
                                    class="px-4"
                                    :disabled="displayLock(courier)"
                                    @click="selectCourier(keyId)"
                                >
                                    <i class="fas fa-check" 
                                        v-if="keyId === isSelected.courierId"
                                    >
                                    </i>
                                    เลือกขนส่ง
                                </b-button>
                            </td>
                        </tr>
                        <!-- <tr :key="`error-msg-${index}`" v-if="objectSize(courier.error)">
                            <td colspan="6" 
                                class="text-center">
                                <i class="fas fa-exclamation text-red m-1"></i>
                                <label>รายการข้อมูลไม่ถูกต้อง {{objectSize(courier.error)}} รายการ 
                                <b class="text-red">กรุณาตรวจสอบข้อมูลก่อนทำการจัดส่งพัสดุ</b></label>
                                <b-button variant="outline-danger" 
                                    class="px-2 m-1" 
                                    size="sm" 
                                    @click="beforeEdit( courier.error )" >
                                    <i class="fas fa-pencil-alt"></i> ตรวจสอบข้อมูล
                                </b-button>
                            </td>
                        </tr>  -->
                    </template>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
import { errorCheckPrice } from '@/plugins/index'

export default {
    props: {
        noteToShop: {
            type: String,
            default: ""
        },
        courierList: {
            type: [Array, Object],
            default: () => {}
        },
        isSelected: {
            type: Object,
            default: () => {}
        }
    },
    data: () => ({
        errorCheckPrice: errorCheckPrice
    }),
    methods:{
        displayLock(courier){
            if(courier.total_price === 0 || !courier['shipment'][0].status){
                return true;
            }

            let areaFreeze = courier.shipment.filter( item => {
                item.remark_area_freeze !== null
            })

            if( areaFreeze.length > 0){
                return true
            }
        },
        selectCourier( keyId ){
            this.isSelected.courierId = keyId;
            this.isSelected.list = this.courierList[keyId];
        },
    }
}

</script>